export default function IosGameControllerA() {
  return (
    <div
      className="ion-icon-ios-game-controller-a"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M369.269,146H142.739C81.541,146,32,191.458,32,255.418C32,319.419,81.541,366,142.739,366h226.529
		C430.49,366,480,319.419,480,255.418C480,191.458,430.49,146,369.269,146z M200,266.697c0,2.698-2.421,5.303-5.238,5.303H160
		v35.139c0,2.83-3.104,4.861-5.803,4.861h-21.427c-2.628,0-4.771-1.918-4.771-4.533V272H92.861c-2.83,0-4.861-3.104-4.861-5.803
		v-21.427c0-2.628,1.918-4.771,4.533-4.771H128v-34.822c0-2.806,1.854-5.178,4.553-5.178h22.145c2.698,0,5.303,2.421,5.303,5.238
		V240h34.822c2.806,0,5.178,1.854,5.178,4.553V266.697z M319.766,275.486c-10.736,0-19.451-8.587-19.451-19.153
		c0-10.565,8.715-19.168,19.451-19.168c10.783,0,19.498,8.603,19.498,19.168C339.264,266.899,330.549,275.486,319.766,275.486z
		 M362.314,317.301c-10.736,0-19.451-8.529-19.451-19.084c0-10.639,8.715-19.153,19.451-19.153c10.783,0,19.498,8.515,19.498,19.153
		C381.812,308.771,373.098,317.301,362.314,317.301z M362.314,233.615c-10.736,0-19.451-8.579-19.451-19.146
		c0-10.567,8.715-19.169,19.451-19.169c10.783,0,19.498,8.602,19.498,19.169C381.812,225.036,373.098,233.615,362.314,233.615z
		 M404.862,275.486c-10.729,0-19.442-8.587-19.442-19.153c0-10.565,8.714-19.168,19.442-19.168c10.737,0,19.452,8.603,19.452,19.168
		C424.314,266.899,415.6,275.486,404.862,275.486z"/>
</g>
</svg>
`,
      }}
    />
  )
}
